import { PageProps, graphql, useStaticQuery } from "gatsby";
import React, {
  Dispatch,
  FC,
  ReactNode,
  createContext,
  useContext,
  useState,
} from "react";

type tagType = {
  illustCurrentTag: string | null;
  setIllustCurrentTag: Dispatch<string | null>;
};

const defaultTag = {
  illustCurrentTag: "",
  setIllustCurrentTag: () => {},
};

const TagContext = createContext<tagType>(defaultTag);

const TagProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [illustCurrentTag, setIllustCurrentTag] = useState<string | null>("");
  const value = { illustCurrentTag, setIllustCurrentTag };
  return <TagContext.Provider value={value}>{children}</TagContext.Provider>;
};

export function useTagContext() {
  return useContext(TagContext);
}

export default TagProvider;
